import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormGroup,
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-admin-right-dialog',
  templateUrl: './right-dialog.component.html',
  styleUrls: ['./right-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class RightDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<RightDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup;
  type = 'model';
  headline: string;
  content: string;
  confirm: string;
  placeholder: string;
  update = false;
  rights = [];
  rightData = {};
  required = Validators.required;

  ngOnInit() {
    this.rightData = {};
    if (this.data) {
      this.headline = 'Update Right';
      this.rights = this.data.rights ?? [];
      if (this.data.right) {
        this.rightData = this.data.right;
        this.update = true;
      }
    }

    const formGroup = {};
    formGroup['name'] = new FormControl(
      this.rightData?.['name'] ?? '',
      this.required
    );
    formGroup['id'] = new FormControl(
      this.rightData?.['id'] ?? '',
      this.required
    );
    formGroup['parentid'] = new FormControl(
      this.rightData?.['parentid'] ?? '',
      this.required
    );
    this.form = new UntypedFormGroup(formGroup);
  }

  cancel() {
    this.dialogRef.close({ result: 'cancel' });
  }

  delete() {
    this.dialogRef.close({ result: 'delete', data: this.form.value });
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close({
        result: this.update ? 'update' : 'add',
        data: this.form.value,
      });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  // Only AlphaNumeric with Some Characters [-_ ]
  alphaNumericWithCharacters(event) {
    const inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets, space, underscore
    if (/[a-zA-Z0-9-_ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
}
